/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../lib/primitives.js";
import { safeParse } from "../lib/schemas.js";
import { Result as SafeParseResult } from "../types/fp.js";
import { SDKValidationError } from "./errors/sdkvalidationerror.js";

export type DataCenter = {
  /**
   * Longitude
   */
  longitude?: string | undefined;
  /**
   * Latitude
   */
  latitude?: string | undefined;
  /**
   * Owner
   */
  owner?: string | undefined;
  /**
   * Region
   */
  region?: string | undefined;
  /**
   * Name
   */
  name?: string | undefined;
  /**
   * Data Center ID
   */
  dcId?: string | undefined;
};

/** @internal */
export const DataCenter$inboundSchema: z.ZodType<
  DataCenter,
  z.ZodTypeDef,
  unknown
> = z.object({
  longitude: z.string().optional(),
  latitude: z.string().optional(),
  owner: z.string().optional(),
  region: z.string().optional(),
  name: z.string().optional(),
  dc_id: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "dc_id": "dcId",
  });
});

/** @internal */
export type DataCenter$Outbound = {
  longitude?: string | undefined;
  latitude?: string | undefined;
  owner?: string | undefined;
  region?: string | undefined;
  name?: string | undefined;
  dc_id?: string | undefined;
};

/** @internal */
export const DataCenter$outboundSchema: z.ZodType<
  DataCenter$Outbound,
  z.ZodTypeDef,
  DataCenter
> = z.object({
  longitude: z.string().optional(),
  latitude: z.string().optional(),
  owner: z.string().optional(),
  region: z.string().optional(),
  name: z.string().optional(),
  dcId: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    dcId: "dc_id",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace DataCenter$ {
  /** @deprecated use `DataCenter$inboundSchema` instead. */
  export const inboundSchema = DataCenter$inboundSchema;
  /** @deprecated use `DataCenter$outboundSchema` instead. */
  export const outboundSchema = DataCenter$outboundSchema;
  /** @deprecated use `DataCenter$Outbound` instead. */
  export type Outbound = DataCenter$Outbound;
}

export function dataCenterToJSON(dataCenter: DataCenter): string {
  return JSON.stringify(DataCenter$outboundSchema.parse(dataCenter));
}

export function dataCenterFromJSON(
  jsonString: string,
): SafeParseResult<DataCenter, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DataCenter$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DataCenter' from JSON`,
  );
}
